import React, { Component } from "react";
import Loadspinner from "../Loadspinner";
import Main from "../Main/Main";
import SearchService from "../../services/SearchService";
import * as images from "../../constants/Images";

import "./SearchBar/Searchbar.css";
import PropTypes from "prop-types";
import SearchMenu from "./SearchComponent";
import AsideCards from "../AsideCards/AsideCards";
import { connect } from 'react-redux';
import { searchFilterData } from '../../redux/actions'
import { analytics } from "../../firebase";
import { logEvent } from 'firebase/analytics'
import DataCards2 from "../DataCards2/DataCards2";
import { getAllPostsQuestions, searchAllPostsQuestionsWithFilters } from "../../constants/ApiEndpoints";
import { APICall } from "../../helpers/API/APICalls";
import AsideCardsNew from "../AsideCards/AsideCardsNew";
import CommonConstants from "../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchList: [],
      isLoading: false,
      word: this.props.location.state?.searchWord,
      oldWord: this.props.location.state?.searchWord,
      isKeyword: this.props.location.state?.isKeyword,
      showModal: false,
      searchData: {},
      isMore: false,
      page: 1
    };
  }

  componentDidMount() {
    if (this.state?.isKeyword) {
      this.getSearchbyKeyword();
    } else {
      this.getMasterSearch(this.props.location.state?.searchData);
    }
  }



  handleWord = (e) => {
    this.setState({ word: e.target.value });
    if (e.target.value != "") {
      this.setState({ isKeyword: true });
    } else {
      this.setState({ isKeyword: false });
    }
  };

  onKeyUp = (e) => {
    if (e?.key?.toLowerCase() == "enter") {
      this.getSearchbyKeyword();
    }
  }

  handleKeySearch = () => {
    if (this.state.isKeyword) {
      this.getSearchbyKeyword();
    }
  };

  openModal = (val) => {
    this.setState({ showModal: val });
  };

  setSearchdata = (searchData) => {
    this.getMasterSearch(searchData);
  };

  getSearchbyKeyword = async (searchData, withFilters = false) => {
    let scrollPosition = getFromEncLocalStorage("position");
    let { word, oldWord, searchList, page } = this.state;
    this.setState({ isLoading: true });
    const isNewSearch = word != oldWord || withFilters;
    let newPage = page;
    if (isNewSearch) {
      newPage = 1;
      this.setState({ page: 1 });
    }

    const searchKnowledgeList =
      withFilters ?
        await this.searchKnowledgeWithFilters(newPage, word, searchData) :
        await this.getKnowledgeNew(newPage, word, searchData);
    const newSearchData = [...new Set([...searchList, ...searchKnowledgeList])];
    this.setState({ searchList: isNewSearch ? searchKnowledgeList : newSearchData });
    this.setState({ isMore: searchKnowledgeList?.length < 10 ? false : true });
    if (searchKnowledgeList?.length > 0) {
      this.setState({ page: newPage + 1 });
      if (this.props.location.state != undefined) {
        window.scrollTo(0, scrollPosition);
      }
    }
    this.setState({ oldWord: word });
    // let searchData = {
    //   search: word,
    // };
    // const res = await SearchService.searchByKeywordList(searchData);
    // if (res) {
    //   this.setState({ searchList: res });
    // }

    //logEvent(analytics(), 'search')
    this.setState({ isLoading: false });
  };

  getMasterSearch = async (searchData) => {
    this.getSearchbyKeyword(searchData, true);
    // let scrollPosition = getFromEncLocalStorage("position");
    // this.setState({ word: "" });
    // this.setState({ isLoading: true });

    // const res = await SearchService.masterSearch(searchData);

    // if (res) {
    //   this.setState({ searchList: res });
    // }
    // if (this.props.location.state != undefined) {
    //   window.scrollTo(0, scrollPosition);
    // }

    // // this.props.history.replace({ pathname : '/search', search : 
    // // "?" + new URLSearchParams({q : JSON.stringify(searchData)}).toString()
    // // })
    // this.props.searchFilterData(searchData);

    // this.setState({ isLoading: false });
  };

  getKnowledgeNew = async (start, searchText, searchData) => {
    const employeeNum = getFromEncLocalStorage("employeenumber");
    const reqBody = {
      "start": (start - 1) * 10,
      "resultsPerPage": 10,
      "searchText": searchText,
      "sortColumn": "",
      "sortDirection": "",
      "userId": employeeNum,
      "searchData": searchData,
      "moduleName": "search",
    }
    const resp = await APICall(getAllPostsQuestions, reqBody)

    if (resp && resp?.message == "Ok") {
      // if (resp?.data?.length < 10) {
      //   setMore(false);
      // }
      return resp?.data;
    }
    return [];
  }

  searchKnowledgeWithFilters = async (start, searchText, searchData) => {
    const reqBody = {
      start: (start - 1) * 10,
      resultsPerPage: 10,
      searchText: searchText,
      sortColumn: "",
      sortDirection: "",
      userId: "",
      searchData: searchData
    }
    const resp = await APICall(searchAllPostsQuestionsWithFilters, reqBody)

    if (resp && resp?.message == "Ok") {
      // if (resp?.data?.length < 10) {
      //   setMore(false);
      // }
      return resp?.data;
    }
    return [];
  }

  rerender = () => {
    if (this.state.isKeyword) {
      this.getSearchbyKeyword();
    } else {
      this.getMasterSearch();
    }
  };

  render() {
    const { isLoading, searchList, showModal, word, isMore } = this.state;

    return (
      <Main>
        <Loadspinner filename="Search.js" isLoading={isLoading} isMiddle="true" />
        <div className="container display-row justify-space-around">
          <DataCards2
            dataList={searchList}
            rerenderParentCallback={this.rerender}
            ismore={isMore}
          />
          <div className="display-col aside-card">
            <div className="search-bar">
              <div className="input-group">
                <button
                  className="btn search-menu-btn"
                  type="button"
                  onClick={() => this.openModal(true)}
                >
                  <img src={images.search_menu} className="search-icons" />
                </button>
                {showModal ? (
                  <SearchMenu
                    handleModal={this.openModal}
                    setSearchData={this.setSearchdata}
                  />
                ) : null}
                <input
                  type="text"
                  className="form-control search-input"
                  value={word}
                  placeholder="Search"
                  onChange={(e) => this.handleWord(e)}
                  onKeyUp={(e) => this.onKeyUp(e)}
                  autoComplete={CommonConstants.autoCompleteInput}
                />
                <button
                  className="btn search-btn"
                  type="button"
                  onClick={this.handleKeySearch}
                >
                  <img src={images.search} className="search-icons" />
                </button>
              </div>
            </div>
            <AsideCardsNew />
          </div>
        </div>
      </Main>
    );
  }
}

const mapDispatchToProps = { searchFilterData }
export default connect(null, mapDispatchToProps)(Search);



Search.propTypes = {
  location: PropTypes.string,
  history: PropTypes.func,
  searchFilterData: PropTypes.func
};
